<template>
    <transition name="fade">
        <template v-if="view == 'grid'">
            <div @click="showInfo"
                 ref="card"
                 :loading="loading"
                 class="card relative flex flex-wrap justify-center border border-grey-lighter overflow-hidden px-0 py-0 cursor-pointer"
            >
                <template v-if="loading">
                    <div class="rounded-lg flex items-center justify-center absolute pin z-50">
                        <app-loader />
                    </div>
                </template>

                <div v-if="file.mime != 'image'" v-html="file.thumb" class="mime-icon flex items-center justify-center  h-5/6">

                </div>

                <div  v-if="file.mime == 'image'" ref="image" class="image-block block w-full h-5/6">

                </div>

                <div class="missing p-8" v-if="missing">
                    <p class="text-center leading-normal">
                        <a :href="file.name" class="text-primary dim" target="_blank">This image</a> could not be found.
                    </p>
                </div>

                <div class="h-1/6 w-full text-center text-xs  border-t border-grey-light bg-grey-lighter flex items-center justify-center">
                    {{ file.name | truncate(30) }}
                </div>

            </div>
        </template>

        <template v-else>
            <div
                 ref="card"
                 :loading="loading"
                 class="relative flex flex-wrap items-center border border-grey-lighter overflow-hidden px-0 py-0"
            >
                <div class="text-center px-3" v-bind:class="{'w-16 h-12': !missing}" style="background-clip:content-box;">
                    <template v-if="loading">
                        <div class="rounded-lg flex items-center justify-center absolute pin z-50">
                            <app-loader />
                        </div>
                    </template>

                    <div v-if="file.mime != 'image'" v-html="file.thumb" class="mime-icon flex items-center justify-center w-full h-full"></div>

                    <div  v-if="file.mime == 'image'" ref="image" class="image-block block w-full h-full"></div>

                    <div class="missing p-8" v-if="missing">
                        <p class="text-center leading-normal">
                            <a :href="file.name" class="text-primary dim" target="_blank">This image</a> could not be found.
                        </p>
                    </div>
                </div>

                <div class="flex-grow flex flex-wrap">
                    <div class="w-1/4 px-3">
                        {{ file.name | truncate(30) }}
                    </div>
                    <div class="w-1/4 px-3">
                        {{ file.size_human }}
                    </div>
                    <div class="w-1/4 px-3">
                        {{ file.dimensions }}
                    </div>
                    <div class="w-1/4 px-3">
                        <span class="text-blue text-sm hover:text-blue-dark mr-2" @click="showInfo">View</span>
                        <span class="text-red text-sm hover:text-red-dark" @click="removeFile">Delete</span>
                    </div>
                </div>
            </div>
        </template>
    </transition>
</template>

<script>
import axios from 'axios';

import Loader from '@/components/Loader';

export default {
    components: {
        'app-loader': Loader
    },

    props: {
        file: {
            type: Object,
            default: function() {
                return { name: '' };
            },
            required: true,
        },
        view: {
            type: String,
            default: 'grid',
        },
    },

    data: () => ({
        loading: true,
        missing: false
    }),

    mounted() {
        if (this.file.mime == 'image') {
            this.$nextTick(() => {
                let imageDiv = document.createElement('div');
                let imageBlog = null;
                imageBlog = this.file.asset;
                imageDiv.style.backgroundImage = "url('" + imageBlog + "')";
                imageDiv.className = 'block w-full h-full bg-center bg-cover h-2/3';
                imageDiv.draggable = false;
                this.$refs.image.appendChild(imageDiv);
                this.loading = false;
            })
        } else {
            this.loading = false;
        }
    },
    methods: {
        showInfo() {
            this.$emit('showInfo', this.file);
        },
        removeFile() {
            this.$emit('delete', this.file);
        }
    },
    filters: {
        truncate: function(text, stop, clamp) {
            return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '');
        },
    },
    watch: {
        'file.loading': function(value) {
            if (value == true) {
                this.loading = true;
            } else {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped  lang="scss">
.card {
    padding: 0 !important;

    &:hover {
        > .image-block,
        > .mime-icon {
            opacity: 0.5;
        }
    }
}

.h-5\/6 {
    height: 83.33333%;
}

.h-1\/6 {
    height: 16.66667%;
}
</style>

<style>
.svg-mime {
    width: 80px;
    height: 75%;
    fill: #62676d;
}
</style>



// WEBPACK FOOTER //
// src/components/filemanager/modules/ImageLoader.vue